import { Box, styled, StyleSystemProps } from '@withjoy/joykit';

export const MobileContainer = styled(Box)``;
export const ExtendedSelect = styled(Box)`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  background-image: none;
  &::-ms-expand {
    display: none;
  }
`;

const mobileContainerStyles: StyleSystemProps = {
  position: 'relative',
  cursor: 'pointer'
};

const mobileSelectStyles: StyleSystemProps = {
  position: 'relative',
  zIndex: 1,
  backgroundColor: 'transparent',
  color: 'transparent',
  border: 'none',
  outline: 'none',
  width: 64,
  cursor: 'pointer',
  _active: {
    border: 'none',
    outline: 'none'
  }
};

const mobileSelectLabelStyles: StyleSystemProps = {
  position: 'absolute',
  top: 0,
  left: 0,
  color: 'white',
  fontWeight: 600,
  columnGap: 3,
  cursor: 'pointer'
};

export const styles = {
  mobileContainer: mobileContainerStyles,
  mobileSelectLabel: mobileSelectLabelStyles,
  mobileSelect: mobileSelectStyles
};
